<template>
  <div>
    {{ content.timeslot.label }}
    <span class="chawget-msg-date">{{ formatDate(date) }}</span>
  </div>
</template>

<script>
import BaseMessage from '@/components/messages/BaseMessage.vue'

export default {
  name: 'TimeslotChoice',
  extends: BaseMessage
}

</script>
